import React, { FC } from "react";
import { Card } from "react-bootstrap";
import { FollowIcon } from "../selectable/analytics/FollowIcon";

interface Props {
    batchId: string;
    buildId: string;
    analyticsVersion: string;
}

export const BuildAnalyticsInfo: FC<Props> = ({
    batchId,
    buildId,
    analyticsVersion
}) => {
    return (
        <Card className="mt-1 mb-1">
            <Card.Header className="d-flex justify-content-start">
                <strong className="text-muted">Analytics Info</strong>
                <div className="ms-2">
                    <FollowIcon buildId={buildId} size="lg" />
                </div>
            </Card.Header>
            <Card.Body className="text-contrast bread-text">
                <p>
                    <b className="text-muted">Build Id:</b> {buildId}
                </p>
                <p>
                    <b className="text-muted">Batch Id:</b> {batchId}
                </p>
                <p>
                    <b className="text-muted">Version Id:</b> {analyticsVersion}
                </p>
            </Card.Body>
        </Card>
    );
};
